import { render, staticRenderFns } from "./DownloadRecordDialog.vue?vue&type=template&id=ca81f048&scoped=true"
import script from "./DownloadRecordDialog.vue?vue&type=script&lang=js"
export * from "./DownloadRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./DownloadRecordDialog.vue?vue&type=style&index=0&id=ca81f048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca81f048",
  null
  
)

export default component.exports